import React from "react";
import { cpJourneyFeatures } from "utils/constant/siteIntro/datrimony";
import { LazyImage } from 'components/image';


function Index() {
    return (
        <div className="flex flex-col items-center h-full min-h-screen text-center text-black">

            <div className="md:w-[45%] font-semibold text-3xl px-3 md:px-0 md:text-[45px] mt-32 mb-16">Essential Features to Elevate your <span className="text-brandRed">Couple squad</span> Journey</div>

            <div className="grid items-center justify-center gap-12 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-28">
                {/* CARD */}
                {cpJourneyFeatures?.map((item, index) => (
                    <div key={index} className="relative w-[350px] p-4 overflow-hidden bg-[#f0f4fe] rounded-2xl shadow-lg h-[450px] group">
                        {/* Text Container */}
                        <div className="absolute inset-0 flex flex-col items-center justify-start text-center transition-opacity duration-500 ease-in-out group-hover:opacity-0">
                            <h2 className="mt-3 mb-2 text-xl font-semibold text-black">{item?.mainText}</h2>
                            <p className="px-4 text-sm text-gray-600">{item?.subText}</p>
                        </div>
                        {/* Image */}
                        <div className="absolute inset-0 flex items-end justify-center transition-transform duration-500 ease-in-out group-hover:scale-150 group-hover:-translate-y-20">
                            <LazyImage src={item?.img} alt="Datrimony" className="object-contain w-auto h-80" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Index;
